import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { useCartStore } from '@/stores/cartStore';
import { CartDrawer } from './CartDrawer';
import { cn } from '@/lib/utils';

const HIDDEN_ROUTES = ['/checkout', '/orders'];

export const CartFab = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const count = useCartStore((s) => s.itemCount());
  const { pathname } = useLocation();

  if (HIDDEN_ROUTES.some((route) => pathname.startsWith(route))) return null;

  return (
    <>
      <button
        onClick={() => setDrawerOpen(true)}
        className={cn(
          'fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full shadow-lg border border-gray-200 transition-all duration-200 cursor-pointer',
          'bg-white text-gray-700 hover:bg-gray-50 hover:shadow-xl hover:scale-105',
          count > 0 ? 'pl-4 pr-3 py-3' : 'p-3.5'
        )}
      >
        <ShoppingCart size={20} />
        {count > 0 && (
          <span className="bg-gray-900 text-white text-xs font-bold rounded-full min-w-[22px] h-[22px] flex items-center justify-center px-1.5">
            {count > 99 ? '99+' : count}
          </span>
        )}
      </button>
      <CartDrawer open={drawerOpen} onOpenChange={setDrawerOpen} />
    </>
  );
};
